import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import QRCode from "qrcode";
// import AdliyaLogo from "../../assets/images/Adliya.png";
// import WorldPayLogo from "../../assets/images/WorldPay.png";
Font.register({
  family: "Roboto",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
  fontWeight: "normal",
});

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    borderLeft: "1px solid #000",
    borderIrght: "1px solid #000",
    marginTop: 18,
  },
  section: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    borderTop: "1px solid #000",
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
    position: "relative",
    marginLeft: 16,
    marginRight: 16,
    marginBottom: 4,
  },
  block1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "20%",
  },
  block2: {
    width: "80%",
    borderLeft: "0.5px solid #000",
    borderRight: "0.5px solid #000",
    position: "relative",
  },
  block3: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "20%",
  },
  text: {
    fontFamily: "Roboto",
    fontSize: 8,
  },
  qrText: {
    fontFamily: "Roboto",
    fontSize: 6,
    marginTop: 32,
    paddingRight: 8,
  },
  center: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "0.5px solid #000",
    paddingVertical: 4,
  },
  centerLeft: {
    width: "80%",
  },
  centerRight: {
    width: "20%",
  },
  centerText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: 8,
    paddingVertical: 0,
    paddingHorizontal: 8,
  },
  centerTextLeft: {
    width: "50%",
    color: "#000",
  },
  centerTextRight: {
    width: "50%",
    textDecoration: "underline",
    textDecorationColor: "#000",
  },
  operatorText: {
    fontSize: 4,
    color: "#000",
    fontFamily: "Roboto",
  },
  block3Text: {
    fontSize: 5,
    textTransform: "uppercase",
    color: "#000",
    fontFamily: "Roboto",
  },
  button: {
    color: "#00bf63",
    border: "3px dashed #00bf63",
    paddingHorizontal: 18,
    paddingVertical: 2,
    borderRadius: 4,
    fontFamily: "Roboto",
    fontWeight: "thin",
    textTransform: "uppercase",
    fontSize: 20,
    zIndex: 1,
    position: "absolute",
    top: "40px",
    left: "10px",
    transform: "rotate(-40deg)",
  },
  buttonRed: {
    color: "#C10000",
    border: "3px dashed #C10000",
    paddingHorizontal: 18,
    paddingVertical: 2,
    borderRadius: 4,
    fontFamily: "Roboto",
    fontWeight: "thin",
    textTransform: "uppercase",
    fontSize: 20,
    zIndex: 1,
    position: "absolute",
    top: "40px",
    left: "10px",
    transform: "rotate(-40deg)",
  },
  duplicateText: {
    position: "absolute",
    top: "40px",
    left: "170px",
    color: "#C10000",
    border: "3px dashed #C10000",
    textTransform: "uppercase",
    paddingHorizontal: 18,
    paddingVertical: 2,
    fontFamily: "Roboto",
    fontSize: 20,
    fontWeight: "thin",
    transform: "rotate(-40deg)",
  },
  centerFooter: {
    display: "flex",
    flexDirection: "row",
  },
  centerTop: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderBottom: "0.5px solid #000",
    paddingVertical: 1,
    paddingHorizontal: 8,
  },
  centerTopLeft: {
    width: "38%",
    fontWeight: "thin",
    fontSize: 6,
    fontFamily: "Roboto",
    color: "#000",
    paddingVertical: 2,
  },
  centerTopRight: {
    width: "40%",
    fontSize: 6,
    fontFamily: "Roboto",
  },
  centerFooterDiv: {
    flex: 1,
    borderRight: "0.5px solid #a9a4a4",
  },
  centerFooterBlock: {
    borderRight: "0.5px solid #a9a4a4",
  },
  footerLabel: {
    fontSize: 6,
    paddingVertical: 2,
    paddingHorizontal: 8,
    fontFamily: "Roboto",
    textAlign: "center",
    borderBottom: "0.5px solid #a9a4a4",
    color: "#000",
  },
  footerText: {
    fontSize: 6,
    paddingVertical: 4,
    paddingHorizontal: 10,
    fontWeight: "bold",
    fontFamily: "Roboto",
    textAlign: "center",
  },
  image: {
    width: "80px",
    height: "80px",
    objectFit: "contain",
  },
  // imageLogo1: {
  //   width: "80%",
  //   height: "15px",
  //   objectFit: "contain",
  //   marginTop: "10px",
  // },
  // imageLogo2: {
  //   width: "80%",
  //   height: "30px",
  //   objectFit: "contain",
  // },
  qrcode: {
    width: "90px",
    height: "90px",
    display: "flex",
  },
});

const url = "https://dunyopay.uz/d/r";

const Check = ({ data, showDuplicateText }) => {
  const [dataMemo, setDataMemo] = useState([]);

  useEffect(() => {
    setDataMemo(data);
  }, [data]);
  console.log(dataMemo);

  return (
    <>
      <Document>
        <Page size="A4" style={styles.page}>
          {dataMemo?.length > 0 &&
            dataMemo?.map((payChequeDetailsData, idx) => {
              return (
                <View key={idx} style={styles.section}>
                  <View style={styles.block1}>
                    {/* <Image style={styles.imageLogo2} src={AdliyaLogo} /> */}
                    {payChequeDetailsData?.id && (
                      <Image
                        style={styles.image}
                        src={QRCode.toDataURL(`
                          ${url}/${payChequeDetailsData?.id}
                        `)}
                      />
                    )}
                    <Text style={styles.operatorText}>
                      Кассир: {payChequeDetailsData?.user_id?.data?.login}
                    </Text>
                    <Text style={styles.operatorText}>"CS EXPRESS PAY" AJ</Text>
                    {/* <Image style={styles.imageLogo1} src={WorldPayLogo} /> */}
                  </View>
                  <View style={styles.block2}>
                    {/* <View style={styles.centerTop}>
                        <Text style={styles.centerTopLeft}>
                          WORLD PAY SERVICE
                        </Text>
                        <Text style={styles.centerTopRight}>
                          {payChequeDetailsData?.structure_id?.data?.name}
                        </Text>
                      </View> */}
                    <View style={styles.center}>
                      <View style={styles.centerLeft}>
                        <Text
                          style={
                            payChequeDetailsData?.status?.int == 2
                              ? styles.button
                              : styles.buttonRed
                          }
                        >
                          {payChequeDetailsData?.status?.int == 2
                            ? "Оплачено"
                            : payChequeDetailsData?.status?.string}
                        </Text>
                        {showDuplicateText && (
                          <Text style={styles.duplicateText}>Дубликат</Text>
                        )}
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>Ташкилот</Text>
                          <Text style={styles.centerTextRight}>
                            "WORLD PAY" MCHJ
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>
                            Банк муассасаси
                          </Text>
                          <Text style={styles.centerTextRight}>
                            "CS EXPRESS PAY" AJ
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>Инвойс</Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.account}
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>
                            Лицевой счет
                          </Text>
                          <Text style={styles.centerTextRight}>
                            {
                              payChequeDetailsData?.cheque_details
                                ?.budget_income
                            }
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>
                            Номер транзакции в системе
                          </Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.id}
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>
                            Номер транзакции банка
                          </Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.partner_transaction_id}
                          </Text>
                        </View>
                        {payChequeDetailsData?.cheque_details?.mfo_receiver && (
                          <View style={styles.centerText}>
                            <Text style={styles.centerTextLeft}>Код банка</Text>
                            <Text style={styles.centerTextRight}>
                              МФО:{" "}
                              {
                                payChequeDetailsData?.cheque_details
                                  ?.mfo_receiver
                              }
                            </Text>
                          </View>
                        )}
                        {payChequeDetailsData?.cheque_details
                          ?.bank_transaction_id && (
                          <View style={styles.centerText}>
                            <Text style={styles.centerTextLeft}>
                              Номер транзакции Мунис
                            </Text>
                            <Text style={styles.centerTextRight}>
                              {
                                payChequeDetailsData?.cheque_details
                                  ?.bank_transaction_id
                              }
                            </Text>
                          </View>
                        )}
                        {payChequeDetailsData?.cheque_details
                          ?.name_receiver && (
                          <View style={styles.centerText}>
                            <Text style={styles.centerTextLeft}>
                              Получатель платежа
                            </Text>
                            <Text style={styles.centerTextRight}>
                              {
                                payChequeDetailsData?.cheque_details
                                  ?.name_receiver
                              }
                            </Text>
                          </View>
                        )}
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>Начислено</Text>
                          <Text style={styles.centerTextRight}>
                            {Number(
                              payChequeDetailsData?.amount,
                            )?.toLocaleString("ru-RU")}{" "}
                            UZS
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>Услуга</Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.vendor_id?.data?.short_name}
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>
                            Плательщик ФИО
                          </Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.payer_full_name}
                          </Text>
                        </View>
                        {/* <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>RRN</Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.rrn}
                          </Text>
                        </View>
                        <View style={styles.centerText}>
                          <Text style={styles.centerTextLeft}>ИП</Text>
                          <Text style={styles.centerTextRight}>
                            {payChequeDetailsData?.card_type !== "corporate"
                              ? "Коорпоративная карта"
                              : "Личная карта"}
                          </Text>
                        </View> */}
                        {/* <View style={styles.centerText}>
                            <Text style={styles.centerTextLeft}>Отделение</Text>
                            <Text style={styles.centerTextRight}>
                              {payChequeDetailsData?.structure_id?.data?.name}
                            </Text>
                          </View> */}
                      </View>
                      <View style={`${styles.block3} ${styles.centerRight}`}>
                        {payChequeDetailsData?.fiscal_details?.qrCodeUrl ? (
                          <Image
                            style={styles.qrcode}
                            src={QRCode.toDataURL(
                              payChequeDetailsData?.fiscal_details?.qrCodeUrl,
                            )}
                          />
                        ) : (
                          <Text style={styles.qrText}>
                            OFD chek sms orqali yuboriladi
                          </Text>
                        )}
                        {payChequeDetailsData?.fiscal_details?.receiptId && (
                          <Text style={styles.block3Text}>
                            Ракам:{" "}
                            {payChequeDetailsData?.fiscal_details?.receiptId}
                          </Text>
                        )}
                        {payChequeDetailsData?.fiscal_details?.terminalId && (
                          <Text style={styles.block3Text}>
                            Терминал:{" "}
                            {payChequeDetailsData?.fiscal_details?.terminalId}
                          </Text>
                        )}
                        {payChequeDetailsData?.fiscal_details?.fiscalSign && (
                          <Text style={styles.block3Text}>
                            Фиск Б:{" "}
                            {payChequeDetailsData?.fiscal_details?.fiscalSign}
                          </Text>
                        )}
                      </View>
                    </View>
                    <View style={styles.centerFooter}>
                      <View style={styles.centerFooterDiv}>
                        <Text style={styles.footerLabel}>Отделение</Text>
                        <Text style={styles.footerLabel}>
                          {payChequeDetailsData?.structure_id?.data?.name}
                        </Text>
                      </View>
                      <View style={styles.centerFooterDiv}>
                        <Text style={styles.footerLabel}>Дата/время</Text>
                        <Text style={styles.footerLabel}>
                          {payChequeDetailsData?.created_at?.date}
                        </Text>
                      </View>
                      <View style={styles.centerFooterDiv}>
                        <Text style={styles.footerLabel}>Обшая сумма</Text>
                        <Text style={styles.footerLabel}>
                          {Number(payChequeDetailsData?.amount)?.toLocaleString(
                            "ru-RU",
                          )}{" "}
                          UZS
                        </Text>
                      </View>
                      <View style={styles.centerFooterDiv}>
                        <Text style={styles.footerLabel}>Подпись</Text>
                        <Text style={styles.footerLabel}>.</Text>
                      </View>
                    </View>
                    <View style={styles.centerFooterBlock}>
                      <Text style={styles.footerLabel}>
                        Тип оплаты:{" "}
                        {
                          payChequeDetailsData?.cheque_details
                            ?.budget_income_name
                        }
                      </Text>
                    </View>
                    <View style={styles.centerFooterBlock}>
                      <Text style={styles.footerLabel}>
                        Обшая сумма:{" "}
                        {Number(payChequeDetailsData?.amount)?.toLocaleString(
                          "ru-RU",
                        )}{" "}
                        UZS
                      </Text>
                    </View>
                  </View>
                </View>
              );
            })}
        </Page>
      </Document>
    </>
  );
};

export default Check;
